import { FC } from 'react';
import styled from 'styled-components';
import { ApplicationsIntro } from 'widgets/applications-list-intro/ui/ApplicationsIntro/ApplicationsIntro';
import { IdeasBanner } from 'widgets/ideas/ui/IdeasBanner/IdeasBanner';

import { TemplatesList } from 'entities/application/ui/TemplatesList/TemplatesList';
import { ApplicationsListM } from 'pages/all-applications/ui/ApplicationsListM/ApplicationsListM';
import { MpSection } from 'shared/ui/MpSection';
import { ApplicationsList } from './ApplicationsList/ApplicationsList';

const ApplicationsListContainerStyled = styled(MpSection)`
	flex-direction: column;
	padding-top: 0;
`;

export const AllApplications: FC = () => (
	<>
		<ApplicationsIntro />
		<ApplicationsListContainerStyled>
			<ApplicationsList />
			<ApplicationsListM />
			<TemplatesList />
		</ApplicationsListContainerStyled>
		<IdeasBanner />
	</>
);
